{
  "schemaVersion": 1,
  "slug": "postman",
  "name": "Postman",
  "description": "Connect Postman's provider-hosted MCP server.",
  "categories": [
    "developer"
  ],
  "featured": false,
  "branding": {
    "logoUrl": "/brands/apps/postman.svg"
  },
  "urlPatterns": [
    "https://mcp.postman.com/*"
  ],
  "docsUrl": "https://learning.postman.com/latest-v-12/docs/reference/postman-api/postman-mcp-server/postman-mcp-remote-server",
  "redirectConstraints": "https-or-loopback-http",
  "methods": [
    {
      "key": "mcp-oauth-minimal",
      "transport": "mcp_remote",
      "auth": "oauth",
      "ownershipModes": [
        "dcr"
      ],
      "whenToUse": "Use browser sign-in for the provider-hosted MCP server.",
      "defaults": {
        "serverUrl": "https://mcp.postman.com/minimal"
      },
      "guidanceMd": "Connect Postman in the browser. A Postman account; OAuth is available for US endpoints and API keys are required for EU endpoints.",
      "riskTier": "S3",
      "label": "US · Browser sign-in",
      "consoleLinks": {
        "docs": "https://learning.postman.com/latest-v-12/docs/reference/postman-api/postman-mcp-server/postman-mcp-remote-server"
      },
      "warnings": [
        "A Postman account; OAuth is available for US endpoints and API keys are required for EU endpoints."
      ],
      "capabilityProfile": {
        "key": "minimal",
        "label": "Minimal",
        "description": "Essential workspace, collection, and environment tools with the smallest tool catalog."
      }
    },
    {
      "key": "mcp-oauth-code",
      "transport": "mcp_remote",
      "auth": "oauth",
      "ownershipModes": [
        "dcr"
      ],
      "whenToUse": "Use browser sign-in for the provider-hosted MCP server.",
      "defaults": {
        "serverUrl": "https://mcp.postman.com/code"
      },
      "guidanceMd": "Connect Postman in the browser. A Postman account; OAuth is available for US endpoints and API keys are required for EU endpoints.",
      "riskTier": "S3",
      "label": "US · Browser sign-in",
      "consoleLinks": {
        "docs": "https://learning.postman.com/latest-v-12/docs/reference/postman-api/postman-mcp-server/postman-mcp-remote-server"
      },
      "warnings": [
        "A Postman account; OAuth is available for US endpoints and API keys are required for EU endpoints."
      ],
      "capabilityProfile": {
        "key": "code",
        "label": "Code",
        "description": "Tools for generating client code from API definitions."
      }
    },
    {
      "key": "mcp-oauth-full",
      "transport": "mcp_remote",
      "auth": "oauth",
      "ownershipModes": [
        "dcr"
      ],
      "whenToUse": "Use browser sign-in for the provider-hosted MCP server.",
      "defaults": {
        "serverUrl": "https://mcp.postman.com/mcp"
      },
      "guidanceMd": "Connect Postman in the browser. A Postman account; OAuth is available for US endpoints and API keys are required for EU endpoints.",
      "riskTier": "S3",
      "label": "US · Browser sign-in",
      "consoleLinks": {
        "docs": "https://learning.postman.com/latest-v-12/docs/reference/postman-api/postman-mcp-server/postman-mcp-remote-server"
      },
      "warnings": [
        "A Postman account; OAuth is available for US endpoints and API keys are required for EU endpoints."
      ],
      "capabilityProfile": {
        "key": "write",
        "label": "Full",
        "description": "All Postman API tools, including write-capable collaboration and advanced features."
      }
    },
    {
      "key": "mcp-eu-key-minimal",
      "transport": "mcp_remote",
      "auth": "api_key",
      "ownershipModes": [
        "customer"
      ],
      "whenToUse": "Use a restricted customer-owned key when browser sign-in is not suitable.",
      "defaults": {
        "serverUrl": "https://mcp.eu.postman.com/minimal"
      },
      "guidanceMd": "Use a customer-created Postman key. A Postman account; OAuth is available for US endpoints and API keys are required for EU endpoints.",
      "riskTier": "S3",
      "label": "EU · API key",
      "credentialFields": [
        {
          "key": "authorization",
          "label": "Postman API key",
          "type": "password",
          "required": true,
          "placeholder": "PMAK-...",
          "secret": true
        }
      ],
      "keyPlacement": {
        "location": "header",
        "name": "Authorization",
        "prefix": "Bearer "
      },
      "consoleLinks": {
        "keys": "https://learning.postman.com/latest-v-12/docs/reference/postman-api/postman-mcp-server/postman-mcp-remote-server",
        "docs": "https://learning.postman.com/latest-v-12/docs/reference/postman-api/postman-mcp-server/postman-mcp-remote-server"
      },
      "warnings": [
        "A Postman account; OAuth is available for US endpoints and API keys are required for EU endpoints."
      ],
      "capabilityProfile": {
        "key": "minimal",
        "label": "Minimal",
        "description": "Essential workspace, collection, and environment tools with the smallest tool catalog."
      }
    },
    {
      "key": "mcp-eu-key-code",
      "transport": "mcp_remote",
      "auth": "api_key",
      "ownershipModes": [
        "customer"
      ],
      "whenToUse": "Use a restricted customer-owned key when browser sign-in is not suitable.",
      "defaults": {
        "serverUrl": "https://mcp.eu.postman.com/code"
      },
      "guidanceMd": "Use a customer-created Postman key. A Postman account; OAuth is available for US endpoints and API keys are required for EU endpoints.",
      "riskTier": "S3",
      "label": "EU · API key",
      "credentialFields": [
        {
          "key": "authorization",
          "label": "Postman API key",
          "type": "password",
          "required": true,
          "placeholder": "PMAK-...",
          "secret": true
        }
      ],
      "keyPlacement": {
        "location": "header",
        "name": "Authorization",
        "prefix": "Bearer "
      },
      "consoleLinks": {
        "keys": "https://learning.postman.com/latest-v-12/docs/reference/postman-api/postman-mcp-server/postman-mcp-remote-server",
        "docs": "https://learning.postman.com/latest-v-12/docs/reference/postman-api/postman-mcp-server/postman-mcp-remote-server"
      },
      "warnings": [
        "A Postman account; OAuth is available for US endpoints and API keys are required for EU endpoints."
      ],
      "capabilityProfile": {
        "key": "code",
        "label": "Code",
        "description": "Tools for generating client code from API definitions."
      }
    },
    {
      "key": "mcp-eu-key-full",
      "transport": "mcp_remote",
      "auth": "api_key",
      "ownershipModes": [
        "customer"
      ],
      "whenToUse": "Use a restricted customer-owned key when browser sign-in is not suitable.",
      "defaults": {
        "serverUrl": "https://mcp.eu.postman.com/mcp"
      },
      "guidanceMd": "Use a customer-created Postman key. A Postman account; OAuth is available for US endpoints and API keys are required for EU endpoints.",
      "riskTier": "S3",
      "label": "EU · API key",
      "credentialFields": [
        {
          "key": "authorization",
          "label": "Postman API key",
          "type": "password",
          "required": true,
          "placeholder": "PMAK-...",
          "secret": true
        }
      ],
      "keyPlacement": {
        "location": "header",
        "name": "Authorization",
        "prefix": "Bearer "
      },
      "consoleLinks": {
        "keys": "https://learning.postman.com/latest-v-12/docs/reference/postman-api/postman-mcp-server/postman-mcp-remote-server",
        "docs": "https://learning.postman.com/latest-v-12/docs/reference/postman-api/postman-mcp-server/postman-mcp-remote-server"
      },
      "warnings": [
        "A Postman account; OAuth is available for US endpoints and API keys are required for EU endpoints."
      ],
      "capabilityProfile": {
        "key": "write",
        "label": "Full",
        "description": "All Postman API tools, including write-capable collaboration and advanced features."
      }
    }
  ]
}
